module.exports = __webpack_public_path__ + "img/home-medicamentos.ab75e891.png";